<template>
    <div>
        <ul class="user-info info-list list-unstyled">
            <li><label>{{ $t('renovar_abono.n_abonado_antiguo', {abonado: teatro.texto_abonado}) }}:</label> {{ abonado.n_abonado_antiguo }}</li>
            <li><label>{{ $t('renovar_abono.n_abonado_nuevo', {abonado: teatro.texto_abonado}) }}:</label> {{ abonado.n_abonado }}</li>
            <li><label>{{ $t('formularios.nombre') }}:</label> {{ abonado.name }} {{ abonado.surnames }}</li>
            <li><label>{{ $t('formularios.nacimiento') }}:</label> {{ abonado.fecha_nacimiento_str }}</li>
            <li><label>{{ $t('formularios.dni') }}:</label> {{ abonado.dni }}</li>
            <li><label>{{ $t('formularios.email') }}:</label> {{ abonado.email }}</li>
            <li v-if="abonado.iban"><label>{{ $t('formularios.iban') }}:</label> {{ abonado.iban }}</li>
            <li v-if="abonado.titular_cuenta"><label>{{ $t('formularios.titular_cuenta') }}:</label> {{ abonado.titular_cuenta }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['abonado', 'asiento'],
        data() {
            return {
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>

<style>

</style>
